import { useMediaQuery, useTheme } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import { CgFileDocument } from "react-icons/cg";
import { FiArrowUpRight } from "react-icons/fi";
import { RxCross1 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import TransoLogo from "../../Assets/TRANSO_logo.png";
import KennovateLogo from "../../Assets/kennovate-Logo.png";
import PiLogo from "../../Assets/pi-Logo.png";
import { useEffect } from "react";
import { getApplicationsData } from "../../Utils/apiServices";
import { useContext } from "react";
import { AuthContext } from "../../Context/authContext";
import moment from "moment";

const Header = React.lazy(() => import("../Header/index"));

const DashBoard = () => {
  const root = document.querySelector(':root');
  const primary = getComputedStyle(root).getPropertyValue('--appTheme')
  const shadeBlack = getComputedStyle(root).getPropertyValue('--appTheme-shade')

  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [meetingData, setMeetingData] = useState([]);
  const {
    state: { user },
  } = useContext(AuthContext);


  const handleModalClose = () => {
    setOpen(!open);
  };

  useEffect(() => {
    getApplicationsData(user?.Id).then(res => {
      console.log(res)
      const meetingData = []
      setData(res?.data)
      res.data.forEach(el => {
        el?.Meeting__r.records?.forEach(elem => {
          console.log(elem, moment(elem?.Start_Date_Time__c).isAfter(moment()))
          if (moment(elem?.Start_Date_Time__c).isAfter(moment().subtract(1, 'days')))
            meetingData.push({ ...elem, Application__c: el.Application__c, Review_Round__c: el.Review_Round__c, PanelId: el?.Id })
        })
      })
      setMeetingData(meetingData)
    }).catch(err => {
      console.log(err)
    })
  }, [])

  console.log(meetingData)

  const [subProfile, setSubProfile] = useState({
    title: "IC Call Day 1 - Startups",
    startups: [
      {
        Name: "PiChain",
        Type: "Information Technology",
        status: "pending",
        logo: PiLogo,
      },
      {
        Name: "Transo",
        Type: "Logistics",
        status: "Evaluated",
        logo: TransoLogo,
      },
      {
        Name: "Kennovate",
        Type: "Enterprise SaaS",
        status: "pending",
        logo: KennovateLogo,
      },
    ],
  });

  const scheduleContent = [
    {
      title: "IC Call Day 1",
      MeetingTime: "June 23, 2023 2pm - 3pm(IST-Kolkata)",
      category: 'startup',
      startUps: [
        {
          Name: "PiChain",
          Type: "Information Technology",
          status: "pending",
          logo: PiLogo,
        },
        {
          Name: "Transo",
          Type: "Logistics",
          status: "Evaluated",
          logo: TransoLogo,
        },
        {
          Name: "Kennovate",
          Type: "Enterprise SaaS",
          status: "pending",
          logo: KennovateLogo,
        },
      ],
    },
  ];

  function getFirstLetters(inputString) {
    const words = inputString?.split(' '); // Split the input string into words
    const firstLetters = words?.map(word => word?.charAt(0)); // Extract the first letter from each word
    return firstLetters?.join(''); // Join the first letters back into a single string
  }

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={() => {
          handleModalClose();
        }}
      >
        <Box component={"div"} width={isMobileScreen ? "100%" : "60%"} height={'70vh'} overflow="scroll" className={`py-4 px-4 border-0 rounded-2 common-modal `} bgcolor={primary}>
          <div className="d-flex justify-content-between pt-1 pb-3">
            <h6 className="font-primary-16-bold m-0 p-0">Scoring Criteria</h6>
            <IconButton
              onClick={() => {
                handleModalClose();
              }}
            >
              <RxCross1 color="white" size={"16px"} />
            </IconButton>
          </div>
          <li className="font-white-14-normal lh-base">Fit with TS's Challenge specific & overall fit with TS Thesis (Weight: 25%)</li>
          <ul className="font-white-14-normal lh-base m-1">Truly Gen AI (or at least a genuine AI startup)</ul>
          <ul className="font-white-14-normal lh-base m-1">Focused on the themes (or at least adjacent areas) we highlighted</ul>
          <ul className="font-white-14-normal lh-base m-1">Operating at a stage (idea to pre-revenue) where TS could secure a good stake with minimal investment</ul>
          <ul className="font-white-14-normal lh-base m-1">TS could make an impact on the growth of the startup</ul>
          <li className="font-white-14-normal lh-base mt-4">Problem Statement & Market Opportunity (Weight: 20%)</li>
          <ul className="font-white-14-normal lh-base m-1">Size of Market (TAM, SAM, SOM)</ul>
          <ul className="font-white-14-normal lh-base m-1">Depth of the problem and need i.e. how pressing is the need</ul>
          <ul className="font-white-14-normal lh-base m-1">Why now (macro factors) and market readiness for immediate adoption</ul>
          <li className="font-white-14-normal lh-base mt-4">Product/Solution - Innovation Quotient (Weight: 20%)</li>
          <ul className="font-white-14-normal lh-base m-1">Uniqueness and Unique Selling Points (USP) as compared to competition</ul>
          <ul className="font-white-14-normal lh-base m-1">Fit of their Product/Solution (planned) for the Problem</ul>
          <ul className="font-white-14-normal lh-base m-1">IP (potential patentable in the future), depth of tech (giving defensibility)</ul>
          <ul className="font-white-14-normal lh-base m-1">How differentiated is their (planned) tech against what is available in the market (including Open Source)</ul>
          <li className="font-white-14-normal lh-base mt-4"> Founding Team (Weight: 25%)</li>
          <ul className="font-white-14-normal lh-base m-1">Technology, especially AI expertise and past AI experience</ul>
          <ul className="font-white-14-normal lh-base m-1">Domain understanding and insights (on the domain they will be focusing on)</ul>
          <ul className="font-white-14-normal lh-base m-1">Understanding of the target segment (behaviors, buying patterns, etc.)</ul>
          <ul className="font-white-14-normal lh-base m-1">How committed are they to this new venture</ul>
          <li className="font-white-14-normal lh-base mt-4">Competition, Business Model (Weight: 10%)</li>
          <ul className="font-white-14-normal lh-base m-1">Competitive Landscape and their ability to win</ul>
          <ul className="font-white-14-normal lh-base m-1">Business Model & Unit Economics</ul>
          <ul className="font-white-14-normal lh-base m-1">Path to profitability</ul>
          <h6 className="font-white-14-normal lh-base mt-3 mb-3">
            Please note that judges are requested to assign a score of between 1 to 5 points for each criterion, with 1 indicating the lowest score and 5 indicating the highest score. This scoring mechanism will assist in a comprehensive evaluation of the participating startups.          </h6>
        </Box>
      </Modal>
      <Header />
      {/*DashBoard header section */}
      <div className="PageContainer">
        <Box component={'div'} bgcolor={shadeBlack} className="card rounded-3 shadow-sm border-0 p-4">
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="row">
                <div className="col-2">
                  <Avatar sx={{ bgcolor: "#07588F", width: 56, height: 56 }}>{user?.Name[0]}</Avatar>
                </div>
                <div className="col-10 px-4">
                  <h2 className="font-white-24-bold text-capitalize">Hey {user?.Name} !</h2>
                  <Box component={'h2'} fontSize={'18px'} color={'#7f7f81'} fontWeight={'500'} className="font-white-18-bold">Welcome to the Jury Portal</Box>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row">
                <div className="col-7">
                  <div className="row">
                    <div className="col-sm-6 mb-3">
                      <h2 className="font-primary-16-bold text-nowrap">
                        Upcoming Sessions&nbsp;
                        <FiArrowUpRight />
                      </h2>
                      <h2 className="font-white-18-bold">{meetingData?.length}</h2>
                    </div>
                    <div className="col-sm-6">
                      <h2 className="font-primary-16-bold text-nowrap">
                        Startups&nbsp;
                        <FiArrowUpRight />
                      </h2>
                      <h2 className="font-white-18-bold">{data?.length}</h2>
                    </div>
                  </div>
                </div>
                <Box component={'div'} color={'#A3AAD0'} fontSize={'16px'} className="col-5  text-end cursor-pointer">
                  <p className="mt-3" onClick={() => { handleModalClose(); }} >
                    <CgFileDocument />
                    &nbsp;Scoring Instructions
                  </p>
                </Box>
              </div>
            </div>
          </div>
        </Box>
        <div className="mt-4 h-100">
          <Grid container spacing={4} height={"520px"}>
            <Grid item className="w-100 h-100" md={6}>
              <Box component={"div"} padding={"24px"} paddingBottom={"0px"} className="card border-0 shadow-sm rounded-3 h-100 hoverborder" bgcolor={shadeBlack} >
                <h2 className="font-white-18-bold">Your Schedule</h2>
                {/* <h2 className="font-white-14-bold">(23 June, Sunday)</h2> */}
                <Box component={"div"} marginTop={"20px"} overflow={"scroll"} height={"65%"}>
                  {meetingData.slice() // Create a shallow copy of the array to avoid modifying the original array
                    .sort((a, b) => {
                      // Compare the Start_Date_Time__c properties for sorting
                      const startTimeA = moment(a.Start_Date_Time__c);
                      const startTimeB = moment(b.Start_Date_Time__c);
                      return startTimeA - startTimeB;
                    }).map((item, index) => (
                      <Box component={"div"} key={index} className="mt-2 cursor-pointer p-3 rounded-1" bgcolor="#25272D" height={"132px"} border={subProfile.title === item.title ? "2px solid #3e3f43" : ""} onClick={() => setSubProfile({ title: item.title, startups: item.startUps })} >
                        <h2 className="font-white-16-bold">{item.Name}</h2>
                        <h2 className="font-grey-14-bold mt-1">
                          Meeting Details: <b className="font-white-14-normal">{`${item?.Start_Date_Time__c && moment(item?.Start_Date_Time__c).format('MMM DD, YYYY hh:mma')} ${item?.End_Date_Time__c && `- ${moment(item?.End_Date_Time__c).format('hh:mma')}`}`}</b>
                        </h2>
                        <Box component={"div"} marginTop={"20px"}>
                          <Box component={'button'} color={"#000000"} fontWeight={'600'} className="primary-contained-button px-3 py-1" onClick={() => { window.open(item?.Meeting_Link__c, "_blank") }}>Join</Box>
                          <button className="font-primary-14-bold border-0 bg-transparent" onClick={() => { navigate("/startup-profile", { state: { Application__c: item?.Application__c, Review_Round__c: item?.Review_Round__c, PanelId: item?.PanelId } }); }}>&nbsp;&nbsp;View Startups {`>>`}</button>
                        </Box>
                      </Box>
                    ))}
                </Box>
                {scheduleContent.length > 3 && (
                  <div className="text-center py-2">
                    <Box component={'div'} color={'white'} fontSize={'16px'} className=" border-0 bg-transparent">Show more</Box>
                  </div>
                )}
              </Box>
            </Grid>
            <Grid item className="w-100 h-100" md={6}>
              <Box component={"div"} paddingBottom={"0px"} paddingTop={"24px"} className="card border-0 shadow-sm rounded-3 h-100" bgcolor={shadeBlack}>
                <h2 className="font-white-18-bold mb-4 px-4">{subProfile.title}</h2>
                <Box component={"div"} overflow={"scroll"} height={"68vh"}>
                  {data?.map((item, index) => {
                    let name = getFirstLetters(item?.Application__r?.Startup_Name__c)
                    return <Box component={"div"} key={index} className="d-flex justify-content-between px-3 w-100 my-4 pb-3 border-bottom-startups" onClick={() => { navigate("/startup-profile", { state: { Application__c: item?.Application__c, Review_Round__c: item?.Review_Round__c, PanelId: item?.Id } }); }} >
                      <div className="d-flex gap-3">
                        <Avatar sx={{ bgcolor: "#07588F", width: 56, height: 56, textTransform: 'uppercase' }}>{name}</Avatar>
                        <div>
                          <h2 className="font-white-20-bold cursor-pointer">{item?.Application__r?.Startup_Name__c}</h2>
                          <h2 className="font-grey-14-bold">{item?.Application__r?.Sector__c}</h2>
                        </div>
                      </div>
                      <div>
                        <div className={item.Is_Review_Complete__c === false ? "review-status-button py-1 rounded-4 text-uppercase px-2" : "done-status-button rounded-4 text-uppercase px-2 py-1"}>{item.Evaluation_Scores__r ? 'Evaluated' : 'Pending'}</div>
                      </div>
                    </Box>
                  })}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DashBoard;
